export { MiscIconsSocialInstagramOriginalDefault } from "./MiscIconsSocialInstagramOriginalDefault";
